export const schemaDraft07 = 'http://json-schema.org/draft-07/schema#';
